import { useEnrollCourseMutation, useGetCoursesQuery } from "@api/course";
import Header from "@components/Header";
import LoadingSpinner from "@components/LoadingSpinner";
import { PasswordInput } from "@components/PasswordInput";
import { useToastEffect } from "@hooks/hooks";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";

function CourseEnrollmentPage() {
  const { courseId } = useParams();
  if (!courseId) {
    throw new Error("Course ID is required");
  }
  const navigate = useNavigate();
  const { t } = useTranslation(["coursePage"]);

  const { data: courses, isLoading, isError, error } = useGetCoursesQuery({});
  useToastEffect({
    isError,
    error,
  });

  const [
    enrollCourse,
    { isSuccess: enrollSuccess, isError: enrollIsError, error: enrollError },
  ] = useEnrollCourseMutation();

  useToastEffect({
    isError: enrollIsError,
    error: enrollError,
  });

  const selectedCourse = useMemo(
    () => courses?.find((course) => course.id === courseId),
    [courses, courseId],
  );

  useEffect(() => {
    if (enrollSuccess || selectedCourse?.isEnrolled) {
      navigate(`/course/${courseId}`);
    }
  }, [enrollSuccess, selectedCourse, navigate, courseId]);

  const [password, setPassword] = useState<string | undefined>();

  return (
    <Header>
      <div className="mt-8 flex flex-col items-center justify-center gap-4 p-4">
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div className="font-bold text-xl">{t("inviteMessage")}</div>
            <div className="font-bold text-4xl">{selectedCourse?.name}</div>

            <div className="flex flex-col gap-4">
              {selectedCourse?.isPasswordProtected && (
                <PasswordInput
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  isError={enrollIsError}
                />
              )}
              <button
                type="button"
                className="btn btn-primary mx-4"
                onClick={() => enrollCourse({ courseId, password })}
              >
                {t("enroll")}
              </button>
            </div>

            <button
              type="button"
              className="btn btn-outline mx-4"
              onClick={() => navigate("/")}
            >
              {t("goToStartpage")}
            </button>
          </>
        )}
      </div>
    </Header>
  );
}

export default CourseEnrollmentPage;
